import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaLeads = {
  index: async(props) => {
    const { default: LeadsIndex } = await import('@/vue_widgets/lsa/leads/index.vue')
    createVueApp(LeadsIndex, { props, sidebar })
  }
}
